/**
 * PC 端 hash 跳转：国内站点挂在 /bloom_web，海外根路径部署无此前缀。
 * 海外构建将 www.webloom.top / www.webloom.cn 替换为 https://bloom.wyforum.org
 */

const IS_INTL = process.env.BUILD_REGION === 'intl'

export const INTL_PC_ORIGIN = 'https://bloom.wyforum.org'

export function getPcHashPrefix () {
  return IS_INTL ? '' : '/bloom_web'
}

/**
 * 站内 hash 路径（含 origin 前的部分），如 /bloom_web/#/foo 或 /#/foo
 * @param {string} routePathWithQuery - 路由路径，可含 query，须以 / 开头；如 '/goods?a=1' 或 '/GameData/x?contestId=1'
 */
export function pcHashHref (routePathWithQuery) {
  let full = routePathWithQuery == null || routePathWithQuery === '' ? '/' : routePathWithQuery
  if (!full.startsWith('/')) full = '/' + full
  if (IS_INTL) {
    return '/#' + full
  }
  return '/bloom_web/#' + full
}

/**
 * 当前站点下的完整 hash URL（用于 location.href / open）
 */
export function pcHashFullUrl (routePathWithQuery) {
  if (typeof window === 'undefined') return ''
  return window.location.origin + pcHashHref(routePathWithQuery)
}

/**
 * PC 端生成给手机打开的 H5 分享/二维码完整 URL
 * 国内：/bloom_h5/#/xxx；海外：https://bloom.wyforum.org/#/xxx（无 /bloom_h5）
 */
export function h5ShareFullUrl (routePathWithQuery) {
  let full = routePathWithQuery == null || routePathWithQuery === '' ? '/' : routePathWithQuery
  if (!full.startsWith('/')) full = '/' + full
  if (IS_INTL) {
    return INTL_PC_ORIGIN + '/#' + full
  }
  if (typeof window === 'undefined') return ''
  const origin = window.location.origin
  if (origin.indexOf('top') > -1) {
    return 'https://www.webloom.top/bloom_h5/#' + full
  }
  if (origin.indexOf('webloom.cn') > -1) {
    return 'https://www.webloom.cn/bloom_h5/#' + full
  }
  return origin + '/bloom_h5/#' + full
}

/**
 * 规范化跳转 URL：海外去掉路径中的 /bloom_web，并将 webloom.top / webloom.cn 换为海外域名
 */
export function normalizePcJumpUrl (url) {
  if (!IS_INTL || url == null || typeof url !== 'string') return url
  let u = url
  u = u.replace(/^https?:\/\/www\.webloom\.top(?=\/|$)/i, INTL_PC_ORIGIN)
  u = u.replace(/^https?:\/\/www\.webloom\.cn(?=\/|$)/i, INTL_PC_ORIGIN)
  u = u.replace(new RegExp(INTL_PC_ORIGIN.replace(/\//g, '\\/') + '\\/bloom_web\\/'), INTL_PC_ORIGIN + '/')
  u = u.replace(/^\/bloom_web(?=\/)/, '')
  return u
}

/**
 * 缴费引导弹窗等：按环境与域名打开 goods 页完整 URL
 */
export function pcGoodsPayUrl (taskRelationId) {
  const query = `?taskRelationId=${taskRelationId}`
  if (IS_INTL) {
    return `${INTL_PC_ORIGIN}/#/goods${query}`
  }
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  if (origin.indexOf('top') > -1 || origin.indexOf('localhost') > -1) {
    return `https://www.webloom.top/bloom_web/#/goods${query}`
  }
  return `https://www.webloom.cn/bloom_web/#/goods${query}`
}



// WEBPACK FOOTER //
// ./src/assets/js/pcJumpUrl.js